import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import SectionBase from '@segment/matcha/recipes/Section'

import TestimonialSlider from '@segment/templates/TestimonialSlider'

import { testimonialData } from './data'

const Testimonials: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSection variant="noCopy">
      <TestimonialSlider data={testimonialData} title={false} innerStyles={false} />
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  max-width: 1260px;
  overflow-x: inherit;
`

export default Testimonials
